export default __webpack_public_path__ + "static/media/theWeepingWoman.b53a848b.jpg";